import React from "react";
import HeaderCards from "../HeaderCards";
import styles from "./annoncesLpHeader.module.css";
import dynamic from "next/dynamic";
import api_call_v2 from "utils/API_CALL/api_call_v2";
import Image from "next/image";

const LPSearchBar: any = dynamic(
  () =>
    import(
      "../../components/LandingPage/Mobile/MobileSearchBar/LPSearchBar"
    ),
  { ssr: true }
);

function index(props) {

  const customHandleRecherche = async (recherche) => {
    let data = {
      geometry_label: null,
      geometry_value: null,
    };
    await (async () => {
      if (recherche.niveau == "pas") {
        try {
          let res = await api_call_v2(undefined, "post", "cartographie/rgc", {
            lat: recherche.lat,
            lng: recherche.lng,
          });

          data = {
            geometry_label: res.data.commune
              ? "commune"
              : res.data.province
                ? "province"
                : res.data.region
                  ? "region"
                  : "region",
            geometry_value: res.data.commune
              ? res.data.commune
              : res.data.province
                ? res.data.province
                : res.data.region
                  ? res.data.region
                  : "",
          };
        } catch (e) {
          data = {
            geometry_label:
              recherche.niveau == "communes"
                ? "commune"
                : recherche.niveau == "pas"
                  ? "commune"
                  : recherche.niveau == "provinces"
                    ? "province"
                    : "region",
            geometry_value: recherche.commune
              ? recherche.commune
              : recherche.province
                ? recherche.province
                : recherche.region
                  ? recherche.region
                  : "",
          };
        }
      } else {
        data = {
          geometry_label:
            recherche.niveau == "communes"
              ? "commune"
              : recherche.niveau == "pas"
                ? "commune"
                : recherche.niveau == "provinces"
                  ? "province"
                  : "region",
          geometry_value: recherche.commune
            ? recherche.commune
            : recherche.province
              ? recherche.province
              : recherche.region
                ? recherche.region
                : "",
        };
      }
    })();

    window.location.href = `/${props.lang
      }/agence-immobiliere-maroc/recherche/?address=${recherche.adresse ? recherche.adresse : ""
      }&glabel=${data.geometry_label}&gvalue=${data?.geometry_value}`;
  };

  return (
    <div
      className={` ${props.isHeaderBlocks ? styles.containerHeaderBlocks : props.agenceImmo ? styles.agenceImmoHead : styles.container
        } ${props.groupFormHeader ? styles.containerGroupForm : null}`}
    >
      <div
        className={`${styles.content__container} ${props.isHeaderBlocks ? styles.content__containerBlocks : ""
          } ${props.groupFormHeader ? styles.container_contentForm : null}`}
      >
        <div className={styles.content__inner}>
          <div className={`${styles.content} ${props.agenceImmo ? styles.contentagence : null}`}>
            <h1 className={`${props.isHeaderBlocks ? styles.titleBlocks : ""}`}>
              {props.title}
            </h1>
            {props.agenceImmo ? null : <p
              className={`${styles.subtitle} ${props.isHeaderBlocks ? styles.subtitleBlocks : ""
                }`}
            >
              {props.subtitle}
            </p>}
            {props.agenceImmo ?
              <LPSearchBar
                display_top_section={false}
                customHandleRecherche={customHandleRecherche}
                title={props.subtitle}
                link={"agence-immobiliere-maroc/recherche"}
                placeholder={
                  props.searchBar
                    ? props.searchBar.Estimer_placeholder[props.lang]
                    : ""
                }
                button_text={props.searchBar.buttonCheck1[props.lang]}
                trouvezAgence={false}
                agenceImmo={true}
                lang={props.lang}
              /> : null}
            {props.component ? <div>{props.component}</div> : null}
            {props.isHeaderBlocks ? (
              <div className={styles.cardsContainer}>
                {props.cardHeader?.length > 0
                  ? props.cardHeader?.map((item, key) => {
                    return (
                      <HeaderCards
                        title={item.title ? item.title[props.lang] : ""}
                        desc={
                          item.description ? item.description[props.lang] : ""
                        }
                        btnText={item.button ? item.button[props.lang] : ""}
                        btnLink={item.buttonLink["fr"]}
                        isPNBlock={item.isProjetNeufBlock}
                        t={props.t}
                        lang={props.lang}
                      />
                    );
                  })
                  : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
      {
        props.agenceImmo ?
          <div>
            <Image
              unoptimized
              src={props.backgroundUrl}
              width={588}
              height={512}
              alt={"agence immo"}
              className={styles.agencImmoImg}
            />
          </div>
          : null
      }
    </div>
  );
}

export default index;
